import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import moment from "moment";
import * as XLSX from "xlsx";
import { Button } from "@mui/material";
import Header from "./Header";
import DataTable from "react-data-table-component";
import TimeRangePicker from "./timepicker";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdMore } from "react-icons/io";
import { Form } from "react-bootstrap";
import { API } from "../Contstant/constant";
import "./product.css"



const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "80vh",
    overflowY: "auto",
    textAlign: "justify",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

function debounce(fn, delay) {
    let timer;

    function debounced(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, delay);
    }

    debounced.cancel = () => clearTimeout(timer);

    return debounced;
}
export default function Subscribe() {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [CDeatils, setCDeatils] = useState([]);
    const [SelectedData, setSelectedData] = useState([]);
    const [limit, setLimit] = useState(20);
    const [deleteId, setDeleteId] = useState(null);
    const [total, setTotal] = useState(0);
    const [SDate, setSDate] = useState({
        start: "",
        end: "",
        starttime: "",
        endtime: "",
    });

    const handleChange = e => {
        const { name, value } = e.target;
        setSDate(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const [Preview, setPreview] = useState(false);
    const [viewProduct, setViewProduct] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const [openRowId, setOpenRowId] = useState(null);
    const [Edit, setEdit] = useState(false);
    const [EditData, setEditData] = useState(null);

    const handleActionClick = (id) => {

        setOpenRowId(openRowId === id ? null : id);
    };
    const columns = [
        { name: "SI NO", cell: (row, index) => <div style={{ width: "300px" }}>{index + 1}</div> },

        { name: "email", selector: row => row.email },

        // {
        //     name: "Action",
        //     cell: row => (
        //         <div className="cursor">
        //             <IoMdMore
        //                 onClick={(e) => {
        //                     e.stopPropagation();
        //                     handleActionClick(row._id);
        //                 }}
        //             />

        //             {openRowId === row._id && (
        //                 <div className="dropdown_list">
        //                     <p
        //                         style={{ cursor: "pointer", color: "red" }}
        //                         onClick={() => handleDeleteSingle(row._id)}>
        //                         Delete
        //                     </p>
        //                     {/* <p
        //                         style={{ cursor: "pointer", color: "skyblue" }}
        //                         onClick={() => handleView(row._id)}>
        //                         View
        //                     </p> */}
        //                     {/* <p
        //                         style={{ cursor: "pointer", color: "green" }}
        //                         onClick={() => handleEdit(row._id)}>
        //                         Edit
        //                     </p> */}
        //                 </div>
        //             )}
        //         </div>
        //     ),
        // },

        {
            name: "email", selector: row => <p
                style={{ cursor: "pointer", color: "red" }}
                onClick={() => handleDeleteSingle(row._id)}>
                Delete
            </p>
        },

    ];



    const handleEdit = async (idd) => {
        setOpenRowId(null);
        setEdit(true)
        const userData = JSON.parse(localStorage.getItem("userData"));

        const res = await axios.get(`${API}/api/subscribe/getbyid/${idd}`);

        setEditData(res.data.data)
    };

    const handleDeleteSingle = (id) => {
        setOpenRowId(null);
        setDeleteId(id);
        setPreview(true);

    };

    useEffect(() => {
        const handleClickOutside = () => setOpenRowId(null);
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);


    const handleDelete = async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userData"));

            if (deleteId) {
                await axios.post(
                    `${API}/api/subscribe/trash/${deleteId}`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${userData?.token}`
                        }
                    }
                );
                setCDeatils(prev => prev.filter(item => item._id !== deleteId));
                setDeleteId(null);
            }

            if (SelectedData.length > 0) {
                await Promise.all(
                    SelectedData.map(item =>
                        axios.post(
                            `${API}/api/subscribe/trash/${item._id}`
                        )
                    )
                );
                setCDeatils(prev =>
                    prev.filter(item => !SelectedData.some(s => s._id === item._id))
                );

                setSelectedData([]);
            }

            setPreview(false);
        } catch (error) {
            console.error(error);
        }
    };



    const debouncedSearch = useMemo(
        () =>
            debounce((value) => {
                setSearchTerm(value);
                setPage(1);
            }, 500),
        []
    );

    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);



    const getUsers = async () => {
        try {


            const res = await axios.get(`${API}/api/subscribe/`);

            console.log(res.data)

            setCDeatils(res.data);

            setTotal(res.data.users.length);

        } catch (error) {
            console.error(error);
        }
    };

    const handleSelecteRow = state => {
        setSelectedData(state.selectedRows);
    };



    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("userData"));
        if (!userData) {
            window.location.assign("/");
        }
    }, []);


    const handleExportProducts = async () => {
        try {
            const data = [
                [
                    "user",
                    "role",

                ],
                ...SelectedData.map((ele) => [
                    ele.firstName,
                    ele.role,
                    moment(ele.createdAt).format("DD-MM-YYYY"),
                ]),
            ];

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, "Products");

            const wbout = XLSX.write(wb, { type: "binary", bookType: "xlsx" });

            function s2ab(s) {
                const buf = new ArrayBuffer(s.length);
                const view = new Uint8Array(buf);
                for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
                return buf;
            }

            const blob = new Blob([s2ab(wbout)], {
                type: "application/octet-stream",
            });

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "users.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating Excel file:", error);
        }
    };



    const handleUpdateRole = async () => {
        try {

            const userData = JSON.parse(localStorage.getItem("userData"));

            await axios.put(
                `${API}/api/auth/update-role/${EditData._id}`,
                { role: EditData.role },
                {
                    headers: {
                        Authorization: `Bearer ${userData?.token}`
                    }
                }
            );

            alert("Role updated successfully");

            setEdit(false);

            getUsers();

        } catch (error) {
            console.error(error);
            alert("Failed to update role");
        }
    };

    return (
        <>


            {viewProduct ? (
                <div className="row p-4">
                    <div className="col-md-1 ">
                        <img
                            width={30}
                            onClick={() => setViewProduct(false)}
                            style={{ cursor: "pointer" }}
                            height={30}
                            src="../Assests/icons8-go-back-26.png"
                            alt=""
                        />
                    </div>
                    <div className="row">
                        <div className="col-md-4"></div>
                    </div>
                </div>
            ) : (
                <>
                    <div className="row m-auto">
                        <div className="col-md-2">
                            <label className="fw-bold">Select Date</label>
                            <input
                                className="col-md-12 mb-2 shadow"
                                type="date"
                                onChange={handleChange}
                                name="start"
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="fw-bold">End Date</label>
                            <input
                                className="col-md-12 mb-2 shadow"
                                type="date"
                                name="end"
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-2 mt-4">
                            {SelectedData?.length > 0 && (
                                <button
                                    className="row m-auto p-2"
                                    style={{
                                        border: "none",
                                        backgroundColor: "red",
                                        color: "white",
                                        borderRadius: "6px",
                                    }}
                                    onClick={() => setPreview(true)}>
                                    Delete
                                </button>
                            )}
                        </div>

                        <div className="col-md-2 mt-4">
                            {SelectedData.length > 0 && (
                                <button className=" mx-4  p-2" style={{ border: "none", backgroundColor: "blue", color: "white", borderRadius: "6px" }} onClick={handleExportProducts}>
                                    Export Excel
                                </button>
                            )}
                        </div>
                    </div>


                    <div style={{ width: "100%", overflowX: "auto" }}>

                        <DataTable
                            columns={columns}
                            data={CDeatils}
                            pagination
                            onSelectedRowsChange={handleSelecteRow}
                            paginationServer
                            paginationTotalRows={total}
                            paginationPerPage={limit}
                            selectableRows
                            onChangePage={(page) => setPage(page)}
                            onChangeRowsPerPage={(newLimit, page) => {
                                setLimit(newLimit);
                                setPage(page);
                            }}
                        />


                    </div>
                    <Modal open={Preview} onClose={() => setPreview(false)}>
                        <Box sx={style}>
                            <h5>
                                {deleteId
                                    ? "Do you really want to delete this user?"
                                    : `Do you really want to delete ${SelectedData.length} users?`}
                            </h5>

                            <p style={{ color: "gray" }}>
                                This action cannot be undone.
                            </p>

                            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setPreview(false);
                                        setDeleteId(null);
                                        setSelectedData([]);
                                    }}
                                >
                                    No
                                </Button>

                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={handleDelete}
                                >
                                    Yes, Delete
                                </Button>
                            </Box>
                        </Box>
                    </Modal>

                </>
            )}


            <Modal open={Edit} onClose={() => setEdit(false)}>
                <Box sx={style}>
                    <form>

                        <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                value={`${EditData?.firstName || ""} ${EditData?.lastName || ""}`}
                                readOnly
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                value={EditData?.email || ""}
                                readOnly
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Role</Form.Label>

                            <Form.Select
                                value={EditData?.role || ""}
                                onChange={(e) =>
                                    setEditData({ ...EditData, role: e.target.value })
                                }
                            >
                                <option value="user">User</option>
                                <option value="admin">Admin</option>
                                <option value="superadmin">Super Admin</option>
                            </Form.Select>
                        </Form.Group>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleUpdateRole}
                        >
                            Update Role
                        </Button>

                    </form>
                </Box>
            </Modal>

        </>
    );
}
